import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { useEffect, useRef } from 'react'
import './ministerio-carceles.css'

type TextBlock = {
  type: 'text'
  style: string
  title: string
  paragraphs: string[]
}

type MediaBlock = {
  type: 'image' | 'video'
  style: string
  src: string
}

type MixedBlock = TextBlock | MediaBlock

const mixedBlocks: MixedBlock[] = [
  {
    type: 'text',
    style: 'linaje-mosaic-item--story-xl',
    title: 'Llamado y obediencia',
    paragraphs: [
      'En el año 2009, uno de nuestros ancianos fue llevado al Preventivo de la zona 18 por una injusticia, acusado de defraudación fiscal. Como su pastor, comencé a visitarlo cada viernes para apoyarlo en oración, pidiendo a Dios que le concediera su pronta libertad.',
      'Después de más de tres meses en esa petición, Dios me habló audiblemente y me dijo: “Me estás pidiendo mal. Me pides que lo saque de la cárcel, pero no me has preguntado para qué lo llevé allí”. La respuesta de Dios fue: “Yo lo llevé para que abran una congregación”.',
      'Movido por el amor hacia nuestro anciano, pregunté: “Pero si adentro ya hay iglesia”; y Dios confirmó: “Yo quiero un pastor para ellos que sea inocente de estar allí. Él no saldrá de allí hasta que forme un pastor dentro de ese lugar”.',
    ],
  },
  { type: 'image', style: 'linaje-mosaic-item--photo-tall', src: '/media/MINCAR/C1.jpeg' },
  { type: 'video', style: 'linaje-mosaic-item--video', src: '/media/MINCAR/C4.mp4' },
  { type: 'image', style: 'linaje-mosaic-item--photo', src: '/media/MINCAR/C2.jpeg' },
  {
    type: 'text',
    style: 'linaje-mosaic-item--story',
    title: 'Formación y expansión',
    paragraphs: [
      'Fue entonces cuando nuestro anciano comenzó a realizar discipulados y yo empecé a llegar, ya no como visita, sino como predicador los sábados. Por la gracia de Dios, la congregación, después de algunos años, alcanzó una membresía de más de 240 miembros.',
      'Posteriormente, debido a que muchos convertidos fueron trasladados a otras cárceles del país, se abrieron nuevas iglesias en distintos centros penitenciarios, como la cárcel de Pavón y la cárcel de Canadá, en Escuintla. También se inició cobertura en cárceles de mujeres y se brindó asistencia a la iglesia de Xela.',
      'La iglesia en la cárcel de Pavón es fruto del trabajo iniciado en la zona 18, al igual que la obra en la cárcel de Escuintla.',
    ],
  },
  { type: 'video', style: 'linaje-mosaic-item--video', src: '/media/MINCAR/C5.mp4' },
  { type: 'video', style: 'linaje-mosaic-item--video', src: '/media/MINCAR/C6.mp4' },
  { type: 'image', style: 'linaje-mosaic-item--photo', src: '/media/MINCAR/C3.jpeg' },
  { type: 'video', style: 'linaje-mosaic-item--video', src: '/media/MINCAR/C7.mp4' },
  {
    type: 'text',
    style: 'linaje-mosaic-item--story-wide',
    title: 'Fruto y continuidad',
    paragraphs: [
      'Después de más de doce años de encarcelamiento, el anciano recibió su libertad al ser declarado inocente. Su trayectoria de fe y servicio continúa hasta hoy, bajo la cobertura del Profeta Tito Pérez, siendo un ejemplo vivo de restauración y propósito divino.',
      'Tras su liberación, el liderazgo del ministerio en el Preventivo se consolidó con nuevos pastores formados bajo su discipulado. La obra siguió creciendo con dedicación y compromiso, asegurando que la luz del Evangelio continuara brillando en las cárceles de Guatemala.',
      'Hoy en día, el Ministerio de Cárceles de Linaje de David sigue impactando vidas en múltiples centros penitenciarios. Hermanos que han salido de prisión se han integrado a diversas congregaciones de Ministerios Ebenezer, llevando consigo su testimonio de transformación. Esta obra trasciende una sola congregación; es un esfuerzo conjunto por el Reino de Dios, demostrando que la redención y la esperanza son posibles incluso en los lugares más oscuros.',
    ],
  },
  { type: 'video', style: 'linaje-mosaic-item--video', src: '/media/MINCAR/C8.mp4' },
  { type: 'video', style: 'linaje-mosaic-item--video', src: '/media/MINCAR/C9.mp4' },
  { type: 'video', style: 'linaje-mosaic-item--video', src: '/media/MINCAR/C10.mp4' },
]

const MinisterioCarceles = () => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!containerRef.current) return

    // Esperar a que los videos se carguen y luego ocultar el botón de menú
    const timer = setTimeout(() => {
      const videos = containerRef.current?.querySelectorAll('video')
      if (videos) {
        videos.forEach((video) => {
          // Intentar acceder al shadow DOM de los controles
          const shadowRoot = video.parentElement
          if (shadowRoot) {
            // Aplicar estilos específicos para ocultar elementos de control
            video.setAttribute('controlsList', 'nodownload')
          }
        })
      }
    }, 300)

    return () => clearTimeout(timer)
  }, [])
  return (
    <div className='linaje-carceles-page' ref={containerRef}>
      <section
        className='linaje-carceles-hero'
        style={{
          backgroundImage:
            "linear-gradient(120deg, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0.22)), url('/media/MINCAR/C2.jpeg')",
        }}
      >
        <div className='container'>
          <div className='linaje-carceles-hero__content'>
            <span className='linaje-carceles-kicker'>Ministerio de Cárceles</span>
            <h1>Una obra que lleva esperanza, discipulado y restauración</h1>
            <p>
              Un testimonio vivo de fe, formación y transformación en los centros penitenciarios.
            </p>
          </div>
        </div>
      </section>

      <section className='linaje-carceles-section linaje-carceles-section--mosaic'>
        <div className='container'>
          <div className='linaje-carceles-mosaic'>
            {mixedBlocks.map((block, index) => (
              <article key={`${block.type}-${index}`} className={`linaje-mosaic-item ${block.style}`}>
                {block.type === 'text' && (
                  <div className='linaje-mosaic-story'>
                    <h2>{block.title}</h2>
                    {block.paragraphs.map((paragraph) => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                  </div>
                )}

                {block.type === 'image' && (
                  <img src={toAbsoluteUrl(block.src)} alt='Ministerio de Cárceles' className='linaje-mosaic-media' />
                )}

                {block.type === 'video' && (
                  <video controls controlsList='nodownload' preload='metadata' className='linaje-mosaic-video'>
                    <source src={toAbsoluteUrl(block.src)} type='video/mp4' />
                    Tu navegador no soporta videos.
                  </video>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default MinisterioCarceles